'use client'

import React from 'react'

import type { PaymentStep } from '@/src/utils/holidays/parsePaymentSchedule'

import PaymentSchedule from './paymentSchedule'

interface PaymentScheduleWrapperProps {
    steps: PaymentStep[]
    isMobile: boolean
}

const PaymentScheduleWrapper: React.FC<PaymentScheduleWrapperProps> = ({ steps, isMobile }) => {
    if (!steps.length) return null

    return <PaymentSchedule steps={steps} isMobile={isMobile} />
}

export { PaymentScheduleWrapper }
export default PaymentScheduleWrapper
